import { AccordionOnlyUseBasic } from "@/components/features/items/edit/_shared/ui/components/system/accordion/only-use-basic/accordion";
import { ScConnectedInactiveSettings } from "@/components/features/items/edit/plan/_shared/ui/components/sc-connected";

import { useDayTripPlanIsDayTripRoot } from "./hooks";
import { QuestionPlanIsRoomPriceFree } from "./is-room-price-free";
import { QuestionPlanIsShowRoomForGuest } from "./is-show-room-for-guest";
import { useDayTripPlanScConnected } from "../../price-and-policy/sc-connected";

export const QuestionPlanIsDayTripRoot = () => {
	const { isDayTrip, hotelID, isEdited } = useDayTripPlanIsDayTripRoot();
	const { isSCConnected } = useDayTripPlanScConnected();

	return (
		<AccordionOnlyUseBasic hotelID={hotelID} accordionTitle="日帰りプランに関する設定" defaultOpen={isEdited}>
			{isDayTrip.value && (
				<>
					<QuestionPlanIsShowRoomForGuest />
					<ScConnectedInactiveSettings inactive={Boolean(isSCConnected?.value)}>
						<QuestionPlanIsRoomPriceFree />
					</ScConnectedInactiveSettings>
				</>
			)}
		</AccordionOnlyUseBasic>
	);
};

QuestionPlanIsDayTripRoot.displayName = "QuestionPlanIsDayTripRoot";
